<template>
	<div>
		<c-dialog ref="selector" title="选择报销项" height="80vh" :button="false" enable-flex>
			<ul v-if="type != 2" class="tab flex-start-center">
				<li :class="{'z-crt': currentTab == 1}" @click="tabHandle(1)">公共费用</li>
				<li :class="{'z-crt': currentTab == 2}" @click="tabHandle(2)">个人费用</li>
			</ul>

			<c-scroll ref="scroll" class="flex-grow">
				<c-empty v-if="dataList && !dataList.length"></c-empty>
				<div v-for="(item, i) in dataList" :key="i" :ref="i" class="item flex-center" @click="clickHandle(item)">
					<div class="check flex-center" :class="{'z-crt': currentList.find(crt => crt.value == item.value)}"><i class="c-icon-check"></i></div>
					<p class="flex-grow ellipsis">{{item.name}}</p>
				</div>
			</c-scroll>

			<div class="current flex-between-center" :style="{'z-index': showCurrentList ? 1010 : 90}">
				<div class="flex-center" @click="currentListHandle">
					<span class="total">已选：<span :style="{'color': currentList.length ? '#00ACA9' : ''}">{{currentList.length}}项</span></span>
					<i v-if="currentList.length" class="angle tf-angle-up" :style="{'transform': showCurrentList ? 'rotate(180deg)' : ''}"></i>
				</div>
				<c-button color="main" size="dialog" @click="resolveHandle">确定</c-button>
			</div>
		</c-dialog>

		<c-dialog ref="currentList" :title="`已选中 (${currentList.length})`" :button="false" mask-close @close="currentListClose">
			<c-scroll class="current-list">
				<div v-for="(item, i) in currentList" :key="i" :ref="i" class="item flex-center" @click="currentList.splice(i, 1)">
					<div class="check flex-center" :class="{'z-crt': currentList.find(crt => crt.value == item.value)}"><i class="c-icon-check"></i></div>
					<p class="flex-grow ellipsis">{{item.name}}</p>
				</div>
			</c-scroll>
		</c-dialog>
	</div>
</template>

<script>
	export default {
		name: 'reimbSelector',

		props: {
			type: Number,
			multiple: Boolean
		},

		data() {
			return {
				keyword: '',
				currentTab: 1,
				dataList: null,
				currentList: [],

				showCurrentList: false
			}
		},

		methods: {
			open(data = {}) {
				this.outsourceCount = data.outsourceCount;
				this.$refs.selector.open();
				this.keyword = '';
				this.currentTab = 1;
				this.dataList = null;
				this.currentList = [];
				this.updateList();
			},

			tabHandle(val) {
				this.currentTab = val;
				this.updateList();
			},

			updateList() {
				this.dataList = null;
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DIC_INFO',
						dic_code: 'COMMONEXPENSE_ITEM',
						keyword: this.keyword.trim(),
						kind: this.type == 2 ? 3 : this.currentTab
					},
					success: data => {
						if (!this.outsourceCount) {
							data = data.filter(item => item.value != 8);
						}
						this.dataList = data;
					}
				})
			},

			clickHandle(data) {
				if (this.multiple) {
					if (this.currentList.find(item => item.value == data.value)) {
						this.currentList.splice(this.currentList.findIndex(item => item.value == data.value), 1);
					} else {
						this.currentList.push(data);
					}
				} else {
					this.currentList = [data];
				}
			},

			currentListHandle() {
				if (this.showCurrentList) {
					this.$refs.currentList.close();
				} else if (this.currentList.length) {
					this.showCurrentList = true;
					this.$refs.currentList.open();
				}
			},

			currentListClose() {
				setTimeout(() => {
					this.showCurrentList = false;
				}, 400);
			},

			resolveHandle() {
				if (!this.currentList.length) {
					this.$message({
						message: '未选择人员'
					});
					return;
				}

				this.$refs.selector.close();
				this.$emit('resolve', this.currentList);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.tab {
		gap: .18rem;
		height: 1.02rem;
		padding: 0 .22rem;

		li {
			border-radius: .3rem;
			padding: 0 .24rem;
			line-height: .6rem;
			font-size: .28rem;
			color: #666;
			background: #F5F5F5;

			&.z-crt {
				color: #00A1E9;
				background: #F0F9FE;
			}
		}
	}

	.item {
		gap: .26rem;
		height: .9rem;
		border-bottom: .01rem solid #eee;
		padding: 0 .08rem;
		margin: 0 .24rem;
		font-size: .32rem;

		.check {
			box-sizing: border-box;
			width: .4rem;
			height: .4rem;
			border: .04rem solid #ccc;
			border-radius: .08rem;
			font-size: .22rem;
			color: #fff;
			box-shadow: 3px 3px 8px 0 rgba(0,0,0,.1);

			&.z-crt {
				border-color: var(--color-main);
				background: var(--color-main);
			}
		}
	}

	.current {
		gap: .35rem;
		min-height: 1.2rem;
		border-top: 1px solid #eee;
		padding: 0 .32rem var(--safe-area);
		background: #fff;

		&-list {
			height: 50vh;
		}

		.total {
			font-size: .3rem;
			color: #666;
		}

		.angle {
			margin-left: .22rem;
			font-size: .24rem;
			color: #B1BBCF;
		}
	}
</style>
